var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dropdown',{staticClass:"nav-el-dropdown",on:{"command":_vm.handleCommand}},[_c('span',{staticClass:"el-dropdown-link"},[_c('img',{attrs:{"src":require("../../../assets/images/scb/bei.png"),"alt":""}}),_c('span',[_vm._v("北美求职")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }